import type { ValidationResult } from "@entrilia/shared/utilities/validators";
import { combineValidators, maxCharactersValidator, requiredValidator } from "@entrilia/shared/utilities/validators";

export interface GeneralInboxSettingsForm {
  name: string;
  description: string;
  touchedFields: FieldKey[];
}

type FieldKey = "name" | "description";

interface GeneralInboxSettingsFormValidationResult {
  isValid: boolean;
  name: ValidationResult;
  description: ValidationResult;
}

const validateName = combineValidators(requiredValidator, maxCharactersValidator(50));
const validateDescription = requiredValidator;

export const validateGeneralInboxSettingsForm = (
  form: GeneralInboxSettingsForm
): GeneralInboxSettingsFormValidationResult => {
  const nameResult = validateName(form.name);
  const descriptionResult = validateDescription(form.description);

  const isValid = nameResult.isValid && descriptionResult.isValid;

  return {
    isValid,
    name: nameResult,
    description: descriptionResult,
  };
};
